<agpr-dialog-container
    [id]="id"
    heading="Briefings.canvasSaveTemplateDialog.saveDialogHeading"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="cancel()"
>
    <div
        class="agpr-canvasSaveTemplateDialog-content"
        role="radiogroup"
        [attr.aria-label]="'Briefings.canvasSaveTemplateDialog.saveDialogOptions' | localize"
    >
        <div class="agpr-canvasSaveTemplateDialog-inputGroup">
            <agpr-radio
                [id]="id + '_createRadio'"
                class="agpr-canvasSaveTemplateDialog-radio"
                [value]="saveTemplateState.NEW"
                [(ngModel)]="saveType"
                (ngModelChange)="validate()"
                name="canvas_save_options"
                label="Briefings.briefingSaveTemplateDialog.saveAsNewLabel"
                hiddenLabel="Briefings.briefingSaveTemplateDialog.saveAsNewLabel"
            ></agpr-radio>
            <agpr-text-input
                [id]="id + '_newStyleNameInput'"
                class="agpr-canvasSaveTemplateDialog-inputField"
                ariaLabel="Briefings.briefingSaveTemplateDialog.saveAsNewPlaceholder"
                [(ngModel)]="newTemplateName"
                (ngModelChange)="validate()"
                [placeholder]="'Briefings.briefingSaveTemplateDialog.saveAsNewPlaceholder' | localize"
                [maxLength]="64"
                [bottomMargin]="false"
                [disabled]="saveType === saveTemplateState.UPDATE"
            ></agpr-text-input>
            @if (isDuplicateName) {
                <agpr-form-message class="agpr-canvasSaveTemplateDialog-inputField">
                    {{ 'Briefings.saveBriefingTemplateDuplicateNameErrorMessage' | localize }}
                </agpr-form-message>
            }
        </div>

        <div class="agpr-canvasSaveTemplateDialog-inputGroup agpr-canvasSaveTemplateDialog-inputGroup--updateExisting">
            <agpr-radio
                [id]="id + '_updateRadio'"
                class="agpr-canvasSaveTemplateDialog-radio"
                [value]="saveTemplateState.UPDATE"
                [(ngModel)]="saveType"
                (ngModelChange)="validate()"
                name="canvas_save_options"
                label="Briefings.briefingSaveTemplateDialog.updateExistingLabel"
                hiddenLabel="Briefings.briefingSaveTemplateDialog.updateExistingLabel"
            ></agpr-radio>
            <agpr-dropdown
                [id]="id + '_updateDropdown'"
                class="agpr-canvasSaveTemplateDialog-inputField"
                placeholder="Briefings.briefingSaveTemplateDialog.updateExistingPlaceholder"
                [disabled]="saveType === saveTemplateState.NEW"
                [(ngModel)]="existingTemplateDropdown"
                (ngModelChange)="validate()"
                [options]="canvasTemplateListItems"
                optionLabel="name"
                ariaLabel="Briefings.briefingSaveTemplateDialog.updateExistingLabel"
            ></agpr-dropdown>
        </div>

        <div class="agpr-canvasSaveTemplateDialog-templateContent">
            <div class="agpr-canvasSaveTemplateDialog-templateContentLabel">
                {{ 'Briefings.canvasSaveTemplateDialog.setTemplateContent' | localize }}
            </div>
            <div class="agpr-canvasSaveTemplateDialog-treeContainer">
                <agpr-tree-list
                    [hideParentCheckbox]="false"
                    [items]="templateOptions"
                    [(selection)]="selectedOptions"
                    (selectionChange)="handleOptionChange()"
                ></agpr-tree-list>
            </div>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        @if (saveType === saveTemplateState.NEW) {
            <agpr-button
                [id]="id + '_createButton'"
                label="Briefings.saveTemplateDialog.createLabel"
                [style]="buttonTypes.primary"
                (click)="create()"
                [disabled]="!formValid"
            ></agpr-button>
        } @else if (saveType === saveTemplateState.UPDATE) {
            <agpr-button
                [id]="id + '_updateButton'"
                label="Briefings.saveTemplateDialog.updateLabel"
                [style]="buttonTypes.primary"
                (click)="update()"
                [disabled]="!formValid"
            ></agpr-button>
        }
    </ng-template>
</agpr-dialog-container>
